import type { HeaderNavLink } from './header';

export const headerData: HeaderNavLink[] = [
  {
    linkUrl: '/food-handlers/texas/',
    linkLabel: 'Food Handler',
    menuSize: '340px',
    isDropDown: false,
  },
  {
    linkUrl: '/seller-server/texas/',
    linkLabel: 'Seller Server',
    menuSize: '340px',
    isDropDown: false,
  },
  {
    linkUrl: '/about/',
    linkLabel: 'About',
    menuSize: '340px',
    isDropDown: false,
  },
  {
    linkUrl: '/resources/',
    linkLabel: 'Resources',
    menuSize: '340px',
    isDropDown: false,
  },
];

export const myAccountData: HeaderNavLink[] = [
  {
    linkUrl: '#',
    linkLabel: 'My Account',
    menuSize: '180px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: 'https://app.aceable.com/user/signin?v=HSP',
        linkLabel: 'Sign In',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/support/',
        linkLabel: 'Help Center',
        newTab: false,
        nofollow: false,
      },
    ],
  },
];

export const loggedInMyAccountData: HeaderNavLink[] = [
  {
    linkUrl: '#',
    linkLabel: 'My Account',
    menuSize: '180px',
    isDropDown: true,
    ddList: [
      {
        linkUrl: 'https://app.aceable.com/user/signin?v=HSP',
        linkLabel: 'My Dashboard',
        newTab: false,
        nofollow: false,
      },
      {
        linkUrl: '/support/',
        linkLabel: 'Help Center',
        newTab: false,
        nofollow: false,
      },
    ],
  },
];
